import getters from '@/vuex/modules/agencyAccountAuth/getters'
import actions from '@/vuex/modules/agencyAccountAuth/actions'
import mutations from '@/vuex/modules/agencyAccountAuth/mutations'

export const state = {
  previousAuthChain: null,
  currentAuthChain: null,
  isInheritAgency: false,
  currentEditingUserType: null,
}

const namespaced = true

/*
 * アカウント情報を取得・編集するmodule
 */
const account = {
  namespaced: namespaced,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
}

export default account
